import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_itrade.png",
      alt: "Estratégias iTrade",
    },
    title: "Opere de forma automatizada com iTrade",

    // String ou array de strings
    text: [
      "Após 6 anos de sucesso em nossos operacionais, decidimos trazer, de forma automatizada, todos os recursos avançados de nossas estratégias para o mercado financeiro. Tudo foi pensado e elaborado para melhorar a performance dos seus trades, potencializar sua gestão de risco e excluir o fator emocional.",
    ],
    testimonial: {
      text: "O segredo de ganhar no mercado não é estar certo o tempo todo. A chave é perder a menor quantidade de dinheiro possível quando estiver errado.",
      author: {
        name: "William O'Neil",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias iTrade",
    heading: "Estratégias automatizadas à sua disposição.",
    subtitle:
      "Estratégias automatizadas com recursos profissionais. Comece agora mesmo.",
  },

  cta: {
    title: "Inscreva-se agora!",
    subtitle: "Ative agora mesmo a extensão iTrade",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "iTrade",
    col1: [
      "A iTrade foi criada com a visão de proporcionar aos traders ferramentas inovadoras e eficazes para melhorar a performance das operações no mercado financeiro.",
      "Utilizando estratégias próprias e profissionais ao longo dos anos conseguimos proporcionar aos traders um melhor acompanhamento das movimentações do mercado e com a automatização  conseguimos potencializar performance, gestão de risco e excluir o fator emocional, assim como otimizar o tempo dos nossos traders.",
    ],
    // col2: [
    //   "Utilizando estratégias próprias e profissionais ao longo dos anos conseguimos proporcionar aos traders um melhor acompanhamento das movimentações do mercado e com a automatização  conseguimos potencializar performance, gestão de risco e excluir o fator emocional, assim como otimizar o tempo dos nossos traders.",
    // ],
  },

  // stats: {
  //   title: "Alguns números da SSBot",
  //   subtitle: "Há 5 anos operando de forma automatizada em escala global.",
  //   data: [
  //     {
  //       value: "5",
  //       description: "Anos em atividade",
  //     },
  //     {
  //       value: "+10",
  //       description: "Estratégias validadas",
  //     },
  //     {
  //       value: "+8M",
  //       description: "Ordens executadas por ano",
  //     },
  //   ],
  // },

  features: {
    title: "Por que utilizar os robôs da SSBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da SSBot.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão iTrade",
  },

  // testimonials: [
  //   {
  //     text: "A Newbot é muito mais que estratégias para robôs que realmente funcionam, é atendimento especializado, orientação plena e aprendizado. Parabéns Edson e equipe!",
  //     author: "Eliseu Sandres",
  //     job: "Bancário",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Além de possuir estratégias extremamente bem refinadas, a Newbot proporciona também conhecimento compartilhado, atendimento direto e rápido e verdadeira preocupação com seus clientes.",
  //     author: "Victor Nardi Vilella",
  //     job: "Arquiteto de Sistemas",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],
};
